import { FinishNewsletterPopupProps } from '@husky-x/cc-finish-newsletter-popup/dist/types/models';

export const FinishProductDifferencesMock = {
  header: '<h2>TUTUSTU TUOTTEIDEMME VERTAILUUN</h2>',
  borderedImage: true,
  navigationButton: {
    link: '/tuotteet/',
    label: 'Näytä kaikki tuotteet',
  },
  useCheckmark: false,
  tables: [
    {
      title: 'FINISH',
      legend:
        '<ul> <li><sup>*</sup>Pinttynyt lika</li> <li><sup>**</sup>vs Finish Power</li> <li><sup>***</sup>Poistaa kiinni palaneet tahrat</li> <li><sup>****</sup>Ainesosat: Entsyymit</li> </ul>',
      rows: [
        {
          text: 'Puhdistus',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltea87c4c628b79c83/672b332d92fc2e334ae4afc0/clean.svg',
        },
        {
          text: 'Kiillottaa',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt93ba453d16253a88/672b332e44232cd2d703667d/glass-protection.svg',
        },
        {
          text: 'Sitkeät 48h kuivuneet tahrat<sup>*</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blta2d07ab69b81d7e0/672b332e385a9f306c89a14c/dried-on.svg',
        },
        {
          text: 'Tehokas rasvanpoistoon',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt4e78d00db65bd109/672b332ef9f8c98e1f5cd550/tough-on-grease.svg',
        },
        {
          text: 'Nopeasti liukeneva',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltce0e76ec7ad8c2ff/672b332ee26ed7180f4b15a8/fast-dissolving.svg',
        },
        {
          text: 'Vähemmän kemiallista kuormaa<sup>**</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt4f5999a44f766119/672b332ea9c28979b0f0865e/less-chemical-weight.svg',
        },
        {
          text: 'Lasin suojaus',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt93ba453d16253a88/672b332e44232cd2d703667d/glass-protection.svg',
        },
        {
          text: 'Raikkauden lisäys',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt6bce8566a25bce5a/672b332eaf4968d9c2937157/freshness-boost.svg',
        },
        {
          text: 'Poistaa kiinni palaneet tahrat***',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blte051fb1e44ab0838/672b332ef082aeb9a04ebbfb/burnt-on-stains.svg',
        },
        {
          text: 'Vapauttaa oikean ainesosan oikeaan aikaan<sup>****</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt80da07055c78fedf/672b332ea688993417c53602/right-ingredient-right-time-1.png',
        },
      ],
      columns: [
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt08b5189ea754374b/6745d0cee749702bd14a1781/ul-plus-group-ro.webp',
          productName: 'FINISH ULTIMATE PLUS',
          productLink: '/tuotteet/astianpesuaineet/quantum-ultimate-konetiskitabletit-plus/20-regular/',
          color: 'gold-gradient',
          values: [
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt412dc7fde5eb3f74/6745d0ce00b14cc60607ec15/ult-group-ro.webp',
          productName: 'FINISH ULTIMATE',
          productLink: '/tuotteet/astianpesuaineet/quantum-ultimate-disktabletter/35-regular/',
          color: 'black-gradient',
          values: [
            {
              value: 4,
            },
            {
              value: 3,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltc945a2c585fafbb2/6745d0cec180342f396aa184/quantum-group-ro.webp',
          productName: 'FINISH QUANTUM',
          productLink: '/tuotteet/astianpesuaineet/quantum-max-konetiskitabletit/60-regular/',
          color: 'dark-blue-gradient',
          values: [
            {
              value: 3,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt02b4cd4f07f8bdd4/6745d0cec458e95978aa470f/power-group-48-ro.webp',
          productName: 'FINISH POWER',
          productLink: '/tuotteet/astianpesuaineet/all-in-1-max-konetiskitabletit/20-regular/',
          color: 'blue-gradient',
          values: [
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
      ],
    },
  ],
};

export const FinishProductCardsMock = {
  cards: [
    {
      productName: 'FINISH ULTIMATE',
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt05252d43328b83ac/673e0c08f3f9b680f32eab69/finish-ultimate.webp',
      cardStyle: 'dark-blue',
      button: {
        link: '/tuotteet/astianpesuaineet/quantum-ultimate-disktabletter/35-regular/',
        text: 'KOKEILE ULTIMATE',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt14c2a732b85ffe95/672b2b6adef94577005dc577/tough-on-grease.webp',
          name: 'Tehokas rasvanpoistoon',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltd91d514e360acde8/672b2b6aa714b7238e595eb2/dried-on-stains.webp',
          name: 'Sitkeät <strong>48</strong>h kuivuneet tahrat<sup>*</sup>',
          styleType: 'text-on-image',
        },
      ],
      mobileOrder: 2,
    },
    {
      productName: 'FINISH ULTIMATE PLUS',
      primary: true,
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt1ca88d9d0b0f47f6/673e0c0822b5cea3a656339c/finish-ultimate-plus-20t.webp',
      cardStyle: 'black',
      button: {
        link: '/tuotteet/astianpesuaineet/quantum-ultimate-konetiskitabletit-plus/20-regular/',
        text: 'KOKEILE ULTIMATE PLUS, MEIDÄN PARAS KONETISKITABLETTIMME',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt116ceb8c905face0/672b2b6a07e8b65425b5cb3d/extra-cleaning-power.webp',
          name: 'Tehokas rasvanpoistoon',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltd2797c2b7eca1490/672b2b6ad58fe80ac644cb9d/tough-on-grease-gold.webp',
          name: 'Sitkeät <strong>48</strong>h kuivuneet tahrat<sup>*</sup>',
          styleType: 'text-on-image',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt56b7c2f9ec89726f/672b2b6a570b83949bb5c91b/burnt-on-stains.webp',
          name: '<strong>3X</strong> enemmän puhdistustehoa',
          styleType: 'text-on-image',
        },
      ],
      mobileOrder: 1,
    },
    {
      productName: 'FINISH QUANTUM',
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt26cb4b30c3939471/673e0c08f59c330f47835bf6/finish-quantum.webp',
      cardStyle: 'light-blue',
      button: {
        link: '/tuotteet/astianpesuaineet/quantum-max-konetiskitabletit/60-regular/',
        text: 'KOKEILE QUANTUM',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt14c2a732b85ffe95/672b2b6adef94577005dc577/tough-on-grease.webp',
          name: 'Tehokas rasvanpoistoon',
        },
      ],
      mobileOrder: 3,
    },
  ],
};

export const FinishNewsletterPopupMock: FinishNewsletterPopupProps = {
  headline: 'NICHTS MEHR VERPASSEN',
  image: {
    src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt7512496341f5a468/66f53c689441d6ee01fe1a7d/newsletter_popup_image.png',
    mobileSrc:
      'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt63c4941b86e10813/66f53c833097ebb254ddd0d8/newsletter_popup_image_mobile.png',
    alt: 'finish',
  },
  thankYou: {
    headline: 'VIELEN DANK FÜR IHRE ANMELDUNG FÜR DEN FINISH NEWSLETTER!',
    description: '',
    closeButton: {
      label: 'schließen',
      redirectUrl: '/',
    },
  },
  form: {
    id: '7f4311c4-00e3-48f9-a9cb-13b20ef2b28f',
    url: 'https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms',
    submitErrorMessage: 'Bitte füllen Sie die erforderlichen Felder aus.',
  },
};
